import type { FC } from 'react';
import React from 'react';
import { Divider } from '@wix/wix-ui-tpa/cssVars';

import EmptyState from './EmptyState';
import Field from './Field';
import { useCustomProfile } from './hooks';
import { classes } from './Overview.st.css';
import SocialLink from './SocialLink';
import Title from './Title';

export const Overview: FC = () => {
  const customProfile = useCustomProfile();
  const { fields, socialLinks } = customProfile;

  if (!fields.length && !socialLinks.length) {
    return (
      <>
        <Title customProfile={customProfile} />
        <EmptyState />
      </>
    );
  }

  return (
    <>
      <Title customProfile={customProfile} />
      {fields.length > 0 && (
        <div>
          {fields.map((field) => (
            <div key={field.id} className={classes.item}>
              <Field field={field} />
            </div>
          ))}
        </div>
      )}
      {fields.length > 0 && socialLinks.length > 0 && (
        <Divider className={classes.divider} />
      )}
      {socialLinks.length > 0 && (
        <div>
          {socialLinks.map((socialLink) => (
            <div key={socialLink.id} className={classes.item}>
              <SocialLink {...socialLink} />
            </div>
          ))}
        </div>
      )}
    </>
  );
};
